import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import { DashboardModuleListItem, Image, Text } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useCampaign'

import type { CurrentUserPayload } from '@hooks/useCurrentUser'

import { CampaignModel } from '@models/campaign'

import type { UserModel } from '@models/types'

import { getCampaignPermissions, getCampaignType } from '@functions/campaign'

import placeholderImageUrl from '../assets/campaign_image_400x400.png'

type CampaignListItemParams = {
  campaign: CampaignModel,
  currentUser: UserModel,
  displayMode: string,
}

const CampaignListItem = (props: CampaignListItemParams) => {
  const {
    campaign, currentUser, displayMode,
  } = props
  const {
    address, default_image, priority_campaign_user_ids: priorityUserIds, suburb_name,
  } = campaign

  const isPriorityCampaignForCurrentUser = priorityUserIds?.includes(currentUser.id)

  const { campaignEditDashboardUrl, campaignQuotesUrl } = generateUrls(campaign)

  const campaignPermissions = getCampaignPermissions({
    user: currentUser,
    campaignType: getCampaignType(campaign),
  })
  const canManageCampaign = campaignPermissions?.orders?.manage ?? false
  const editUrl = canManageCampaign ? campaignEditDashboardUrl : campaignQuotesUrl

  return (
    <DashboardModuleListItem
      href={editUrl}
      // @ts-expect-error TS2322
      imageComponent={displayMode === 'list' && (
        <Image
          backgroundSize="cover"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          placeholderUrl={placeholderImageUrl}
          url={default_image}
        />
      )}
      secondaryText={suburb_name}
      title={address}
    >
      {isPriorityCampaignForCurrentUser && (
        <Text
          color="blue"
          fontSize="small"
          marginRight="small"
        >
          <FontAwesomeIcon icon={faStar} />
        </Text>
      )}
    </DashboardModuleListItem>
  )
}

export default CampaignListItem
